import React from 'react';
import { ChallengeCard } from './ChallengeCard';
import { forgeInterruptChallenge } from '../../data/interruptChallenge';
import styles from './ForgeChallenge.module.css';

/**
 * ForgeInterrupt component displays an urgent interrupt challenge
 * Reuses ForgeChallenge styling for consistency
 */
export const ForgeInterrupt: React.FC = () => {
  const [isCompleted, setIsCompleted] = React.useState(forgeInterruptChallenge.isCompleted);

  const handleToggle = () => {
    setIsCompleted(!isCompleted);
  };

  const challenge = {
    ...forgeInterruptChallenge,
    isCompleted
  };

  return (
    <section className={styles.forgeChallengeSection}>
      <div className={styles.header}>
        <h2 className={styles.title}>🚨 Forge Interrupt</h2>
        <p className={styles.subtitle}>
          An urgent update requires immediate attention
        </p>
      </div>
      
      <div className={styles.cardWrapper}>
        <ChallengeCard
          challenge={challenge}
          onToggleComplete={handleToggle}
          isLoading={false}
        />
      </div>
    </section>
  );
};
